<div class="dialog-template">
  <div class="header-dialog">
    <h3>{{ modalTitle }}</h3>
  </div>

  <form [formGroup]="form" action="">
    <!-- 🔹 Campos para PLANES -->
    <ng-container *ngIf="!isExcedent">
      <div class="form-group">
        <label>Nombre del plan</label>
        <input
          type="text"
          matInput
          fieldSize="medium"
          placeholder="Ingrese el nombre"
          formControlName="title"
        />
      </div>

      <div class="form-group">
        <label>Precio del plan</label>
        <input
          type="text"
          matInput
          fieldSize="medium"
          placeholder="Ingrese un nuevo valor"
          formControlName="precio"
          (input)="onlyNums($event)"
        />
      </div>

      <div class="form-group">
        <label>Horas del plan</label>
        <input
          type="text"
          matInput
          fieldSize="medium"
          placeholder="Ingrese un nuevo valor"
          formControlName="time"
          (input)="onlyNums($event)"
        />
      </div>

      <div class="form-group">
        <label>Minutos de llamada</label>
        <input
          type="text"
          matInput
          fieldSize="medium"
          placeholder="Ingrese un nuevo valor"
          formControlName="minutes"
          (input)="onlyNums($event)"
        />
      </div>
    </ng-container>

    <!-- 🔹 Campos para EXCEDENTES -->
    <ng-container *ngIf="isExcedent">
      <div class="form-group">
        <label>Precio del excedente</label>
        <input
          type="text"
          matInput
          fieldSize="medium"
          placeholder="Ingrese el precio del bloque"
          formControlName="excedentPrice"
          (input)="onlyNums($event)"
        />
      </div>

      <div class="form-group">
        <label>Bloque de horas</label>
        <input
          type="text"
          matInput
          fieldSize="medium"
          placeholder="Ingrese las horas por bloque"
          formControlName="excedentHoursBlock"
          (input)="onlyNums($event)"
        />
      </div>

      <div class="form-group">
        <label>Bloque de minutos de llamadas</label>
        <input
          type="text"
          matInput
          fieldSize="medium"
          placeholder="Ingrese los minutos por bloque"
          formControlName="excedentMinutesBlock"
          (input)="onlyNums($event)"
        />
      </div>
    </ng-container>
  </form>

  <div class="buttons-footer">
    <button class="mr-5" mat-button class="danger" (click)="ref.close()">
      <mat-icon>close</mat-icon> Cancelar
    </button>

    <button mat-button class="success" (click)="submit()">
      <mat-icon>save</mat-icon> {{ isEdit ? "Actualizar" : "Guardar" }}
    </button>
  </div>
</div>
